import React from "react";
import img from "../../../assets/img/blog/Rectangle 92.png";
import profile from "../../../assets/img/temp/profile.png";
import moment from 'jalali-moment'
import { useNavigate } from "react-router-dom";

const BlogLatestCard = ({name,date,des,avatar,slug,id})=>{
  const navigate = useNavigate()

  return(
    <div className="BlogLatestCard flex items-stretch justify-between" onClick={()=>navigate(`/blog/${id}/${slug}`)}>
      <div className="">
        <div className="flex items-center">
           <img  className="BlogLatestCard-profile ml-[10px]" src={profile} alt='' />
           <div className="BlogLatestCard-info">
             <h3>{avatar}</h3>
             <p>منتشر شده در 29 مهر 1401</p>
           </div>

        </div>
        <p className="BlogLatestCard-des">
          {des}
        </p>
      </div>
      <div className="BlogLatestCard-img">
        <img src={img}/>
      </div>
    </div>
  )
}
const BlogLatest = ({BLogInfo}) => {
  return (
    <div className="BlogSidebar-box mt-[50px]">
      <h2>مقالات اخیر</h2>
   {BLogInfo && BLogInfo.slice(0,4).map(i=><BlogLatestCard slug={i.slug} id={i.id}  avatar={i.author.avatar} des={i.title} name={i.author.full_name}/>) }

    </div>
  );
};

export default BlogLatest;
